import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgCaduceus = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.79077 4.86167C9.79077 5.45487 10.0264 6.02377 10.4459 6.44323C10.8653 6.86268 11.4342 7.09833 12.0274 7.09833C12.6206 7.09833 13.1895 6.86268 13.609 6.44323C14.0285 6.02377 14.2641 5.45487 14.2641 4.86167C14.2641 4.26847 14.0285 3.69956 13.609 3.2801C13.1895 2.86065 12.6206 2.625 12.0274 2.625C11.4342 2.625 10.8653 2.86065 10.4459 3.2801C10.0264 3.69956 9.79077 4.26847 9.79077 4.86167V4.86167Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6917 12.5208C14.9459 12.5167 15.1973 12.5743 15.4244 12.6887C15.6515 12.8031 15.8474 12.9708 15.9955 13.1775C16.1435 13.3842 16.2393 13.6237 16.2744 13.8756C16.3096 14.1274 16.2832 14.384 16.1975 14.6233"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0275 7.09833V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0782 5.75H20.6524C22.8832 5.75 19.6524 11.1275 15.0091 9.33333"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.97413 5.75H3.40163C1.17163 5.75 4.40163 11.1275 9.04496 9.33333"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.36247 12.5208C8.9434 12.5166 8.53974 12.6787 8.23998 12.9716C7.94021 13.2645 7.7688 13.6643 7.76331 14.0833C7.76551 14.5103 7.93355 14.9197 8.23193 15.225C8.53031 15.5304 8.93569 15.7079 9.36247 15.72H13.6258C14.0499 15.72 14.4567 15.8885 14.7566 16.1884C15.0565 16.4883 15.225 16.895 15.225 17.3192C15.225 17.7433 15.0565 18.15 14.7566 18.4499C14.4567 18.7499 14.0499 18.9183 13.6258 18.9183H10.695C10.3331 18.9266 9.98928 19.0784 9.73924 19.3401C9.48919 19.6019 9.35337 19.9523 9.36164 20.3142C9.36059 20.5084 9.3993 20.7008 9.4754 20.8795C9.5515 21.0582 9.66338 21.2195 9.80414 21.3533"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgCaduceus.displayName = 'SvgCaduceus';
export default SvgCaduceus;
